import LoadingSpinner from "@/components/LoadingSpinner";
import { Toggle } from "@/components/Toggle";
import { URLInput } from "@/components/URLInput";
import { CopyButton } from "@/components/ui/copy-button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

interface HistoryPageNavbarShareDialogProps {
  isLoading: boolean;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSharingEnabledChange: (value: boolean) => void;
  sharingEnabled: boolean;
  sharingUrl: string;
  sharingUrlDisplay: string;
}

export const HistoryPageNavbarShareDialog = ({
  isLoading,
  isOpen,
  onOpenChange,
  onSharingEnabledChange,
  sharingEnabled,
  sharingUrl,
  sharingUrlDisplay,
}: HistoryPageNavbarShareDialogProps) => (
  <Dialog open={isOpen} onOpenChange={onOpenChange}>
    <DialogContent
      className={cn(
        "overflow-hidden transition-[width,max-width,height,min-height] duration-300 ease-out",
        sharingEnabled ? "max-w-lg" : "max-w-md",
      )}
    >
      <DialogHeader>
        <DialogTitle>Share request</DialogTitle>
        <DialogDescription>
          Enable sharing to generate a public link for this request log.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
          <div className="pr-4">
            <div className="text-sm font-medium text-gray-900">Public link</div>
            <div className="mt-1 text-xs text-gray-500">
              Anyone with the link can view this request.
            </div>
          </div>
          {isLoading ? (
            <LoadingSpinner size={5} />
          ) : (
            <Toggle enabled={sharingEnabled} setEnabled={onSharingEnabledChange} />
          )}
        </div>
        <div
          className={cn(
            "grid transition-all duration-300 ease-out",
            sharingEnabled ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0",
          )}
        >
          <div className="overflow-hidden">
            <div className="space-y-2 pt-1">
              <div className="flex items-end gap-2">
                <URLInput
                  value={sharingUrlDisplay || "Loading..."}
                  onChange={() => undefined}
                  label="Share URL"
                  readOnly
                  className="min-w-0 flex-1"
                  classNameInput="text-gray-600 hover:text-gray-700 focus:text-gray-800"
                />
                <CopyButton
                  text={sharingUrl || "Loading..."}
                  disabled={!sharingEnabled || isLoading}
                  labeledButton
                  buttonLabel="Copy link"
                  className="mb-px shrink-0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
